import { render, staticRenderFns } from "./configList.vue?vue&type=template&id=5f2f8972&scoped=true&"
import script from "./configList.vue?vue&type=script&lang=js&"
export * from "./configList.vue?vue&type=script&lang=js&"
import style0 from "./configList.vue?vue&type=style&index=0&id=5f2f8972&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f2f8972",
  null
  
)

export default component.exports